import {
    GET_GAMES_REQUEST,
    GET_GAMES_SUCCESS,
    GET_GAMES_FAILURE,
    GET_GAME_REQUEST,
    GET_GAME_SUCCESS,
    GET_GAME_FAILURE,
    CREATE_GAME_REQUEST,
    CREATE_GAME_SUCCESS,
    CREATE_GAME_FAILURE,
    UPDATE_GAME_REQUEST,
    UPDATE_GAME_SUCCESS,
    UPDATE_GAME_FAILURE,
    DELETE_GAME_REQUEST,
    DELETE_GAME_SUCCESS,
    DELETE_GAME_FAILURE,
    CLEAR_ALL_GAMES_DATA,
    CLEAR_A_GAME,
    RELEASE_GAME_ANSWER_REQUEST,
    RELEASE_GAME_ANSWER_SUCCESS,
    RELEASE_GAME_ANSWER_FAILURE,
    CLEAR_ALL,
    CLEAR_CREATE_GAME,
    CLEAR_UPDATE_GAME,
    CLEAR_DELETE_GAME,
    GET_ANCHOR_CATEGORIES_REQUEST,
    GET_ANCHOR_CATEGORIES_SUCCESS,
    GET_ANCHOR_CATEGORIES_FAILURE,
} from '../actions/getGameManagement';

const initialState = {
    games_loading: false,
    games_error: null,
    games_data: null,
    anchor_categories_loading: false,
    anchor_categories_error: null,
    anchor_categories_data: null,
    game_loading: false,
    game_error: null,
    game_data: null,
    create_game_loading: false,
    create_game_error: null,
    create_game_data: null,
    update_game_loading: false,
    update_game_error: null,
    update_game_data: null,
    delete_game_loading: false,
    delete_game_error: null,
    delete_game_data: null,
    release_answer_game_loading: false,
    release_answer_game_error: null,
    release_answer_game_data: null,
};

export default function getGameManagementReducer(state = initialState, action) {
    switch (action.type) {
        case GET_GAMES_REQUEST:
            return { ...state, games_loading: true, games_error: null };
        case GET_GAMES_SUCCESS:
            return {
                ...state,
                games_loading: false,
                games_data:
                    action?.payload?.pagination?.page === 1
                        ? action?.payload?.data
                        : [
                            ...new Map([
                                ...(state?.games_data || []),   // keep old items
                                ...(action?.payload?.data || []) // add new page items
                            ].map(item => [item._id, item])).values(),
                        ],
                games_meta: {
                    total: action?.payload?.pagination?.total,
                    totalPages: action?.payload?.pagination?.totalPages,
                    currentPage: action?.payload?.pagination?.page,
                    limit: action?.payload?.pagination?.limit,
                },
            };
        case GET_GAMES_FAILURE:
            return { ...state, games_loading: false, games_error: action.payload };
        case CLEAR_ALL_GAMES_DATA:
            return { ...state, games_loading: false, games_data: null, games_error: null, games_meta: null };

        case GET_ANCHOR_CATEGORIES_REQUEST:
            return { ...state, anchor_categories_loading: true, anchor_categories_error: null };
        case GET_ANCHOR_CATEGORIES_SUCCESS:
            return { ...state, anchor_categories_loading: false, anchor_categories_data: action.payload };
        case GET_ANCHOR_CATEGORIES_FAILURE:
            return { ...state, anchor_categories_loading: false, anchor_categories_error: action.payload };

        case GET_GAME_REQUEST:
            return { ...state, game_loading: true, game_error: null };
        case GET_GAME_SUCCESS:
            return { ...state, game_loading: false, game_data: action.payload };
        case GET_GAME_FAILURE:
            return { ...state, game_loading: false, game_error: action.payload };
        case CLEAR_A_GAME:
            return { ...state, game_loading: false, game_data: null, game_error: null };


        case CREATE_GAME_REQUEST:
            return { ...state, create_game_loading: true, create_game_error: null };
        case CREATE_GAME_SUCCESS:
            return { ...state, create_game_loading: false, create_game_data: action.payload };
        case CREATE_GAME_FAILURE:
            return { ...state, create_game_loading: false, create_game_error: action.payload };

        case UPDATE_GAME_REQUEST:
            return { ...state, update_game_loading: true, update_game_error: null };
        case UPDATE_GAME_SUCCESS:
            return { ...state, update_game_loading: false, update_game_data: action.payload };
        case UPDATE_GAME_FAILURE:
            return { ...state, update_game_loading: false, update_game_error: action.payload };

        case DELETE_GAME_REQUEST:
            return { ...state, delete_game_loading: true, delete_game_error: null };
        case DELETE_GAME_SUCCESS:
            return { ...state, delete_game_loading: false, delete_game_data: action.payload };
        case DELETE_GAME_FAILURE:
            return { ...state, delete_game_loading: false, delete_game_error: action.payload };

        case RELEASE_GAME_ANSWER_REQUEST:
            return { ...state, release_answer_game_loading: true, release_answer_game_error: null };
        case RELEASE_GAME_ANSWER_SUCCESS:
            return { ...state, release_answer_game_loading: false, release_answer_game_data: action.payload };
        case RELEASE_GAME_ANSWER_FAILURE:
            return { ...state, release_answer_game_loading: false, release_answer_game_error: action.payload };

        case CLEAR_CREATE_GAME:
            return { ...state, create_game_loading: false, create_game_data: null, create_game_error: null };

        case CLEAR_UPDATE_GAME:
            return { ...state, update_game_loading: false, update_game_data: null, update_game_error: null };

        case CLEAR_DELETE_GAME:
            return { ...state, delete_game_loading: false, delete_game_data: null, delete_game_error: null };

        // case CLEAR_ALL:
        //     return {
        //         ...state,
        //         games_data: null,
        //         game_data: null,
        //         create_game_data: null,
        //         update_game_data: null,
        //         delete_game_data: null,
        //         release_answer_game_data: null,
        //     };
        default:
            return state;
    }
}